import React from "react";
import PropTypes from "prop-types";
import { PiArrowLeft, PiArrowRight, PiPaperPlaneRight } from "react-icons/pi";
import { Button } from "@/components/buttons";

/**
 * WizardFooter — sticky bottom bar inside the wizard card.
 *
 * "Back" is disabled on the first step.
 * "Next Step" advances with per-step validation; on the last step it becomes "Submit Application".
 */
export default function WizardFooter({ isFirstStep, isLastStep, isSubmitting, onBack, onNext, onSubmit }) {
  return (
    <div className="flex shrink-0 items-center justify-between border-t border-gray-200 bg-gray-50 px-6 py-4 sm:px-8 dark:border-slate-700 dark:bg-slate-800/50">
      <Button
        type="button"
        variant="outline"
        label="Back"
        icon={<PiArrowLeft className="size-4" />}
        isDisabled={isFirstStep || isSubmitting}
        onClick={onBack}
      />
      {isLastStep ? (
        <Button
          type="button"
          variant="primary"
          label="Submit Application"
          icon={<PiPaperPlaneRight className="size-4" />}
          isLoading={isSubmitting}
          onClick={onSubmit}
        />
      ) : (
        <Button
          type="button"
          variant="primary"
          label="Next Step"
          onClick={onNext}
        >
          <PiArrowRight className="size-4" />
        </Button>
      )}
    </div>
  );
}

WizardFooter.propTypes = {
  isFirstStep: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

